import { useMutation, useQuery } from "@tanstack/react-query"
import { ColumnsType } from "antd/es/table"
import { getProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow, getProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow, updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest } from "../../../../service/programBooking"
import { EProgramBookingStatus, textToProgramBookingStatusMap } from "../../../wellnessProgram/program/booking/model"
import dayjs from "dayjs"

const bookedColumns: ColumnsType<IProgramBookingCheckInAdminResponseItem> = [
    { title: '프로그램명', dataIndex: 'programTitle' },
    { title: '이용 날짜', dataIndex: 'targetDateTime', render: q => dayjs(q).format('YYYY.MM.DD') },
    { title: '이용 시간', dataIndex: 'targetDateTime', render: q => dayjs(q).format('HH:mm') },
    { title: '옵션', render: (_, record) => <>{record.programBookingCheckInSelectOptionList.map(q => q.programSelectOptionName + ': ' + q.programSelectOptionItemNameList.join(', '))} <br /> {record.programBookingCheckInSubjectOptionList.map(w => w.programSubjectOptionName + ': ' + w.content)}</> },
    { title: '참석상태', dataIndex: 'status', render: q => q === EProgramBookingStatus.CHECK_IN ? 'Y' : 'X' },
    { title: '티켓', dataIndex: 'programBookingCheckInTicketList', render: (q: IProgramBookingCheckInTicketAdminResponse[]) => q.filter(w => w.count > 0).map(w => w.name).join(' \n') },
    { title: '인원', dataIndex: 'programBookingCheckInTicketList', render: (q: IProgramBookingCheckInTicketAdminResponse[]) => q.filter(w => w.count > 0).map(w => w.count).join(' \n') },
]

const availableCheckInColumns: ColumnsType<IProgramBookingCheckInAdminResponseItem> = [
    { title: '프로그램명', dataIndex: 'programTitle' },
    { title: '이용 날짜', dataIndex: 'targetDateTime', render: q => dayjs(q).format('YYYY.MM.DD') },
    { title: '이용 시간', dataIndex: 'targetDateTime', render: q => dayjs(q).format('HH:mm') },
    { title: '옵션', render: (_, record) => <>{record.programBookingCheckInSelectOptionList.map(q => q.programSelectOptionName + ': ' + q.programSelectOptionItemNameList.join(', '))} <br /> {record.programBookingCheckInSubjectOptionList.map(w => w.programSubjectOptionName + ': ' + w.content)}</> },
    { title: '참석상태', dataIndex: 'status', render: q => (textToProgramBookingStatusMap[q] ?? q) === EProgramBookingStatus.CHECK_IN ? 'Y' : 'X' },
    { title: '티켓', dataIndex: 'programBookingCheckInTicketList', render: (q: IProgramBookingCheckInTicketAdminResponse[]) => q.filter(w => w.count > 0).map(w => w.name).join(' \n') },
    { title: '인원', dataIndex: 'programBookingCheckInTicketList', render: (q: IProgramBookingCheckInTicketAdminResponse[]) => q.filter(w => w.count > 0).map(w => w.count).join(' \n') },
]

const useGetProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow = (memberMobile: string, status: string) => {
    const query = useQuery({
        queryKey: ['getProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow', memberMobile, status],
        queryFn: () => getProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow(memberMobile, status),
        enabled: !!memberMobile && memberMobile.length === 11 && !!status,
        select: res => res.data
    })

    return query;
}

const useGetProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow = (programBookingId?: number) => {
    const query = useQuery({
        queryKey: ['getProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow', programBookingId],
        queryFn: () => getProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow(programBookingId as number),
        enabled: !!programBookingId,
        select: res => res.data
    })

    return query;
}

const useUpdateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest = () => {
    const mutation = useMutation({
        mutationFn: updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest,
    })

    return mutation

}



export { bookedColumns, availableCheckInColumns, useGetProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow, useGetProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow, useUpdateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest }